export default () => {
  return window.location.hostname === 'local.tartuntatietoni.fi'
    ? 'local.tartuntatietoni.fi:3000'
    : window.location.hostname;
};
